import * as React from "react";
import * as ReactModal from "react-modal";

interface RequestChangeForAssetNoticeProps {
    open: boolean;
    handleUserShowNotice: (clicked: boolean) => void;
    onClose: () => void;
}

export default function RequestChangeForAssetNotice(
    props: RequestChangeForAssetNoticeProps
) {
    const [open, setOpen] = React.useState(props.open);

    const handleOkClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
        props.handleUserShowNotice(true);
        setOpen(false);
    };

    const modalContent: JSX.Element = (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div
                        className="alert alert-warning alert-dismissible fade show"
                        role="alert"
                    >
                        <p>
                            <strong className="text-primary">Note!</strong>{" "}
                            Creating a new asset or editing asset details can
                            normally take up to 2-3 business days to get
                            approved
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <button
                        className="btn btn-primary float-right"
                        onClick={(e) => handleOkClicked(e)}
                    >
                        Send
                    </button>
                </div>
            </div>
        </div>
    );

    return open ? (
        <ReactModal
            onRequestClose={() => props.onClose()}
            isOpen={open}
            contentLabel="Modal"
            styles={{}}
            defaultStyles={{}}
        >
            {modalContent}
        </ReactModal>
    ) : null;
}
